import React, { ReactNode } from 'react';
import { Typography } from '../../../../wag-react/components/Typography';
import { Box } from '../../../../wag-react/next-components/box';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { Image } from '../../../../wag-react/next-components/image';
import { theme } from '../../../../wag-react/themes/base-theme';
export type UGCItemProps = {
  datePosted: string;
  HeaderComponent: ReactNode;
  images?: string[];
  text: string;
  userLabel: string;
};
export const UGCItem = ({
  datePosted,
  HeaderComponent,
  images,
  text,
  userLabel
}: UGCItemProps) => <>
    {HeaderComponent}
    <Box p="20px" data-sentry-element="Box" data-sentry-source-file="index.tsx">
      {images.map(image => <Image key={image} alt="User generated photo" src={image} borderRadius="75px" mr="8px" height="120px" width="120px" style={{
      objectFit: 'cover'
    }} />)}

      <Typography data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {text}
      </Typography>

      <Flex justifyContent="space-between" mt="16px" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Typography color={theme.colors.darkGray} fontSize="14px" m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {datePosted}
        </Typography>

        <Typography color={theme.colors.darkGray} fontSize="14px" m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {userLabel}
        </Typography>
      </Flex>
    </Box>
  </>;